import { inject, type InjectionKey } from 'vue';

export function requireInject<T>(key: InjectionKey<T>, name = 'injection'): T {
    const resolved = inject(key);

    if (resolved === undefined) {
        throw new Error(`${name} was not provided`);
    }

    return resolved;
}
